module.exports = __webpack_public_path__ + "static/media/bliksem.c07dd7c8.png";